import React, { useEffect, useState } from "react";
import Table, {
	ActionCollumn,
	DuaArabicCell,
	SelectColumnFilter,
} from "./components/user_table";
import UploadModal from "../../components/upload_modal";
import ApiService from "../../api/app.api";
import CreateModal from "../../components/create_modal";
import DashboardLayout from "../layouts/admin_layout";
import Breadcrumb from "../../components/bread_crumb";
import { Link } from "react-router-dom";
import folder from "../../assets/folder.png";
import DropdownSelect from "../../components/dropdown_select";
import AddCategory from "../../components/add_category";
import { useSelector } from "react-redux";
import IconButton from "../../components/icon_button";
import { MdOutlineDelete, MdOutlineEdit } from "react-icons/md";
import axios from "axios";

const api = new ApiService();
export default function DuasDir() {
	const [data, setData] = useState([]);
	const [success, setSuccess] = useState({});
	const user = useSelector((st) => st.user).user;
	useEffect(() => {
		fetchData();
	}, []);
	const fetchData = async () => {
		try {
			const response = await api.getRequest(
				"api/v1/duas/categories?limit=50",
				user.token
			);
			const res = response.data.duaCategories;
			setData(res);
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};
	const handleDelete = async (id) => {
		if (!window.confirm("Delete this folder and everything inside it?")) return;
		try {
			await api.deleteRequest(`api/v1/duas/${id}`, user.token);
			fetchData();
		} catch (error) {
			console.error("Delete error:", error);
		}
	};

	// const data = React.useMemo(() => getDuas(), []);
	const routes = [
		{ name: "Dashboard", path: "/" },
		{ name: "Duas", path: "/duas" },
	];
	return (
		<DashboardLayout>
			{" "}
			<div className="flex justify-between items-center mx-4 my-2">
				<Breadcrumb routes={routes} />
				<div className="flex  justify-between justify-items-center">
					{/* <UploadModal /> */}
					<AddCategory refetch={fetchData} />
				</div>
			</div>
			<div className="flex flex-wrap mt-6 mx-8 ">
				{data.map((item, index) => (
					<div className="w-1/11 p-4 relative flex flex-col" key={index}>
						<Link
							to={`/dua/${item.title}`}
							state={{ id: item.id, name: item.name }}
							className="" // Add this class for positioning
						>
							<div className=" rounded-md p-1">
								<img src={folder} alt="Folder" className="w-12 mx-auto mb-1" />
								<p className="text-center whitespace-pre-line ">
									{item.title.substring(0, 21)}
								</p>
							</div>
						</Link>{" "}
						{/* Delete and Edit icons */}
						<div className="absolute bottom-0 right-0 left-0 opacity-0 transition-opacity duration-300 hover:opacity-100 flex items-center justify-center">
							<IconButton
								icon={MdOutlineDelete}
								label="delete"
								onClick={() => handleDelete(item.id)}
								color="text-red-500"
								size={18}
							/>
						</div>
					</div>
				))}
			</div>
		</DashboardLayout>
	);
}
const objects = [
	{ name: "text", instructions: "Step 1 " },
	{ name: "text", instructions: "Step 2" },
	{ name: " ", instructions: "step 2 cont.." },
	{ name: "text", instructions: "Step 4 " },
	{ name: "", instructions: "" },
	{ name: "text", instructions: "Step 6 " },
	{ name: "", instructions: "" },
	{ name: "text", instructions: "Step 7" },
	{ name: "", instructions: "Step 7 cont..." },
];

const newobjects = [
	{ name: "text", instructions: "Step 1 " },
	{ name: "text", instructions: "Step 2 step 2 cont.." },

	{ name: "text", instructions: "Step 4 " },

	{ name: "text", instructions: "Step 6 " },

	{ name: "text", instructions: "Step 7 Step 7 cont..." },
];
